<template>
	<el-dialog :visible.sync="kai" :show-close="false" v-if="kai">
		<div slot="title">
			<el-autocomplete style="width: 100%" popper-class="my-autocomplete" v-model="guanjianci" placeholder="请输入内容"
			 :trigger-on-focus="false" :fetch-suggestions="querySearch" @select="handleSelect">
				<i class="el-icon-search el-input__icon" slot="suffix"></i>
				<template slot-scope="{item}">
					<div class="name">{{item.value}}</div>
					<span class="addr">{{item.dizhi}}</span>
				</template>
			</el-autocomplete>
		</div>
		<div ref="map" id="map" style="width: 100%;height: 400px;"></div>
		<span slot="footer">
			<el-button @click="kai = false">取 消</el-button>
			<el-button type="primary" @click="Queren">确 定</el-button>
		</span>
	</el-dialog>  
</template>

<script>
	import AMapJS from "amap-js";
	let map, marker, autoComplete;
	let that;
	export default {
		data() {
			return {
				kai: false,
				guanjianci: '',
				shu: {}
			}
		},
		mounted() {
			that = this;
		},
		methods: {
			CSH(jingdu, weidu) {
			
				that.kai = true;
				const aMapJSAPILoader = new AMapJS.AMapJSAPILoader({
					v: "1.4.12",
					key: "b663e672cbe64d5c392e7164a937159a"
				});
				const aMapUILoader = new AMapJS.AMapUILoader({
					v: "1.0"
				});
				aMapJSAPILoader.load().then(AMap => {
					aMapUILoader.load().then(initAMapUI => {
						const AMapUI = initAMapUI(); // 这里调用initAMapUI初始化并返回AMapUI   		
						map = new AMap.Map(this.$refs.map, {
							zoom: 13, //级别			 
							resizeEnable: true,
						});
						AMap.plugin('AMap.Autocomplete', function() {
							autoComplete = new AMap.Autocomplete();
						})
						if (jingdu && weidu) {
							that.addMarker(jingdu, weidu);
						}

					});
				})
			},
			addMarker(jingdu, weidu) {
				if (marker) {
					map.remove(marker);
				}
				marker = new AMap.Marker({
					position: [jingdu, weidu]
				});
				marker.setMap(map);
				this.Shezhizhongxindian(jingdu, weidu);
			},
			querySearch(keyword, cb) {			
				var lie = [];
				autoComplete.search(keyword, function(status, result) {				
					if (result.tips) {						
						for (var i in result.tips) {
							if (result.tips[i].location) {
								lie.push({
									jingdu: result.tips[i].location.lng,
									weidu: result.tips[i].location.lat,
									value: result.tips[i].name,
									shengshiqu: result.tips[i].district,
									dizhi: result.tips[i].address
								});
							}
						}

					}else{
						if(result=='INVALID_USER_DOMAIN'){
							result='测试域名无法使用，请上传正式服务器';
						}
						that.$xiaoxi(result);
					}
					cb(lie);
				})
			},
			handleSelect(e) {
				this.shu = e;
				this.addMarker(e.jingdu, e.weidu);
			},
			Shezhizhongxindian(jingdu, weidu) {
				map.setCenter([jingdu, weidu]);
			},
			Queren() {
				this.kai = false;
				this.$emit('queren', this.shu);
			}


		}
	};
</script>
<style>
	.el-autocomplete-suggestion.my-autocomplete li {
		line-height: normal;
		padding-top: 7px;
		padding-bottom: 7px;
	}

	.el-autocomplete-suggestion.my-autocomplete li .name {
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.el-autocomplete-suggestion.my-autocomplete li .addr {
		font-size: 12px;
		color: #b4b4b4;
	}
</style>
